import React from 'react';
import './LoadingState.css';

const LoadingState = ({ message = "Preparing your adventure...", showLoader = true }) => {
  return (
    <div className="loading-container">
      <div className="loading-content">
        {/* Animated Icon Area */}
        <div className="loader-visual">
          <div className="pulse-circle"></div>
          <div className="icon-overlay">🎯</div>
        </div>
        
        {/* Dynamic Text */}
        <h3 className="loading-message">{message}</h3>
        
        {/* Subtle Progress Bar Animation */}
        {showLoader && (
          <div className="loading-track">
            <div className="loading-fill"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingState;